// extracted by mini-css-extract-plugin
export var fullHeightState = "_48-7";
export var headerCell = "_48-1";
export var loadingStateCell = "_48-4";
export var rowWrapper = "_48-3";
export var standaloneTable = "_48-8";
export var standaloneTableWithBodyFill = "_48-9";
export var stateCell = "_48-5";
export var table = "_48-0";
export var tableBodyFiller = "_48-6";
export var white = "_48-2";